const defaultHeaders = {
  'Content-Type': 'application/json',
  'Accept-Language': 'EN'
};

const responseHandlers = {
  checkOk: (res: Response) => {
    if (!res.ok) {
      throw new Error('HTTP status code: ' + res.status, {
        cause: { response: res }
      });
    }
    return res;
  },
  convertFromJson: (res: Response) => {
    if (!res.headers.get('content-type')?.includes('application/json')) {
      throw new Error(
        'Expected content type to be application/json but found: ' +
          res.headers.get('content-type'),
        {
          cause: { response: res }
        }
      );
    }
    return res.json();
  }
};

const getConfig = (body?: any, headers: HeadersInit = {}): RequestInit => {
  const transformedHeaders = { ...defaultHeaders, ...headers };
  const transformedBody =
    transformedHeaders['Content-Type'] === 'application/json' && body
      ? JSON.stringify(body)
      : body;
  return {
    credentials: 'include',
    headers: transformedHeaders,
    body: transformedBody
  };
};

export const httpClient = {
  get: <T>(url: string, headers: HeadersInit = {}): Promise<T> => {
    return fetch(url, {
      ...getConfig(undefined, headers)
    })
      .then(responseHandlers.checkOk)
      .then(responseHandlers.convertFromJson);
  },

  post: (
    url: string,
    body: any,
    headers: HeadersInit = {}
  ): Promise<Response> => {
    return fetch(url, {
      ...getConfig(body, headers),
      method: 'POST'
    }).then(responseHandlers.checkOk);
  },

  put: async (
    url: string,
    body: any,
    headers: HeadersInit = {}
  ): Promise<Response> => {
    return fetch(url, {
      ...getConfig(body, headers),
      method: 'PUT'
    }).then(responseHandlers.checkOk);
  },

  delete: async (url: string, headers: HeadersInit = {}): Promise<Response> => {
    return fetch(url, {
      ...getConfig(undefined, headers),
      method: 'DELETE'
    }).then(responseHandlers.checkOk);
  }
};
